// Produkty zakładki /aplikacje — NIE dodawać „wkrótce" do katalogu sklepu (db.products).
// APPS: produkty „wkrótce" — bez ceny i bez koszyka, tylko opis + lista oczekujących.
// AVAILABLE_APPS: istniejące produkty sklepu — karty z ceną i zakupem jak w katalogu
// (dane produktu pobierane z /api/products po storeId, link do /produkt/:id).
// Opis kart dostępnych produktów pochodzi z product.description w sklepie.

export const APP_CATEGORIES = [
  { id: "edukacja", label: "Edukacja", primary: true },
  { id: "motoryzacja", label: "Motoryzacja" },
  { id: "zdrowie", label: "Zdrowie, dieta i fitness" },
  { id: "firma", label: "Firma i finanse" },
  { id: "prawo", label: "Prawo" },
  { id: "technologia", label: "Komputer i technologia" },
  { id: "multimedia", label: "Multimedia i kreatywność" },
  { id: "sport", label: "Sport" },
  { id: "kariera", label: "Praca i kariera" },
  { id: "pakiety", label: "Pakiety promocyjne" },
];

export const AVAILABLE_APPS = [
  // Edukacja — wszystkie aplikacje edukacyjne ze sklepu
  { storeId: "digitutor-ai", categories: ["edukacja"] },
  { storeId: "digitutor-kids", categories: ["edukacja"] },
  { storeId: "digilingua-angielski", categories: ["edukacja"] },
  { storeId: "digilingua-hiszpanski", categories: ["edukacja"] },
  { storeId: "digilingua-niemiecki", categories: ["edukacja"] },
  { storeId: "digilingua-francuski", categories: ["edukacja"] },
  { storeId: "digilingua-chinski", categories: ["edukacja"] },
  { storeId: "digilib-world-matematyka", categories: ["edukacja"] },
  { storeId: "digilib-world-angielski", categories: ["edukacja"] },
  { storeId: "digilib-world-polski", categories: ["edukacja"] },
  { storeId: "digilib-world-historia", categories: ["edukacja"] },
  { storeId: "digilib-world-geografia", categories: ["edukacja"] },
  { storeId: "digilib-world-przyroda", categories: ["edukacja"] },
  { storeId: "digilib-world-kodowanie", categories: ["edukacja"] },
  { storeId: "digilib-race-matematyka", categories: ["edukacja"] },
  { storeId: "digilib-race-angielski", categories: ["edukacja"] },
  { storeId: "digilib-race-geografia", categories: ["edukacja"] },
  { storeId: "digilib-race-przyroda", categories: ["edukacja"] },
  { storeId: "digilib-race-historia", categories: ["edukacja"] },
  { storeId: "digilib-race-polski", categories: ["edukacja"] },
  { storeId: "digilib-race-kodowanie", categories: ["edukacja"] },
  { storeId: "digikids-matematyka", categories: ["edukacja"] },
  { storeId: "digikids-czytanie", categories: ["edukacja"] },
  { storeId: "digimind-pamiec", categories: ["edukacja"] },
  // Pakiety promocyjne
  { storeId: "pakiet-aplikacje", categories: ["pakiety"] },
  { storeId: "pakiet-ebooki", categories: ["pakiety"] },
  { storeId: "pakiet-audiobooki", categories: ["pakiety"] },
  { storeId: "digilib-pakiet-kids", categories: ["pakiety"] },
  { storeId: "digilib-world-pakiet", categories: ["pakiety"] },
  // Firma i finanse
  { storeId: "digifin", categories: ["firma"] },
  { storeId: "digioffice-pakiet", categories: ["firma"] },
  { storeId: "digisms", categories: ["firma"] },
  // Prawo — dostępne
  { storeId: "digilaw-prawo", categories: ["prawo"] },
  // Motoryzacja — dostępne
  { storeId: "digiauto-diagnosta", categories: ["motoryzacja"] },
  { storeId: "digiauto-egzamin-b", categories: ["motoryzacja"] },
  { storeId: "digitest-osmoklasista", categories: ["edukacja"] },
  // Zdrowie — dostępne
  { storeId: "digifit-trener", categories: ["zdrowie"] },
  // Komputer i technologia
  { storeId: "digipc-service", categories: ["technologia"] },
  { storeId: "digimusic-studio", categories: ["multimedia"] },
  // Multimedia i kreatywność — dostępne
  { storeId: "digivideo-studio", categories: ["multimedia"] },
  { storeId: "digimusic-dj", categories: ["multimedia"] },
  { storeId: "digiphoto-studio", categories: ["multimedia"] },
  { storeId: "digiarchitekt", categories: ["multimedia"] },
  { storeId: "digijob", categories: ["kariera"] },
  { storeId: "digiai", categories: ["technologia"] },
  { storeId: "digisafe", categories: ["firma", "technologia"] },
  { storeId: "digisafe-prywatny", categories: ["technologia"] },
  { storeId: "digimaps", categories: ["motoryzacja"] },
  { storeId: "digimaps-tir", categories: ["motoryzacja"] },
  // Usługa live — dostępna (rezerwacja i płatność na /live/, poza koszykiem sklepu)
  { href: "/aplikacje/digilive", categories: ["zdrowie"], service: {
      id: "digilive",
      title: "DigiLive Hypnotherapy",
      short: "Profesjonalna hipnoterapia na żywo: indywidualna sesja 1:1 (60 min) z prawdziwą, wykwalifikowaną terapeutką. Pierwsza konsultacja wstępna 20 min GRATIS. To nie jest nagranie ani chatbot AI.",
      price: 349,
      unit: "za sesję",
      cover: "/img/covers/digilive.jpg",
    } },
];

export const APPS = [
  // Zapowiedzi (status "soon") — opisy celowo ogólne do czasu sprawdzenia szczegółów prawnych i technicznych
  {
    id: "digisong",
    title: "DigiSong — Twoja Piosenka z AI",
    short: "Opisz pomysł, a AI stworzy piosenkę z melodią, tekstem i wokalem.",
    categories: ["multimedia"],
    cover: "/img/covers/digisong.jpg",
    accent: "from-fuchsia-500 to-cyan-400",
    status: "soon",
    desc: "DigiSong zamienia pomysł w gotową piosenkę. Opisz nastrój, gatunek i temat — na urodziny, wesele, do filmiku albo po prostu dla zabawy — a AI przygotuje tekst, melodię i wokal. Tekst możesz poprawić po swojemu i wygenerować kolejne wersje, aż utwór będzie brzmiał tak, jak chcesz.",
    features: [
      "Piosenka z opisu: gatunek, nastrój, temat",
      "Tekst po polsku i w innych językach — z możliwością edycji",
      "Wokal i podkład w różnych stylach muzycznych",
      "Kilka wersji utworu do wyboru",
      "Biblioteka Twoich utworów i pobieranie plików",
    ],
  },
  {
    id: "digisport-football",
    title: "DigiSport Football — Analizy i Prognozy Meczów",
    short: "Statystyki, forma drużyn i prognozy wyników meczów piłkarskich z analizą AI.",
    categories: ["sport"],
    cover: "/img/covers/digisport-football.jpg",
    accent: "from-emerald-400 to-cyan-500",
    status: "soon",
    desc: "DigiSport Football zbiera w jednym miejscu dane o meczach piłkarskich: formę drużyn, historię spotkań, wyniki i statystyki. Na ich podstawie AI przygotowuje analizę przed meczem i prognozę procentową możliwych wyników — z wyjaśnieniem, skąd się wzięła. To narzędzie analityczne dla kibiców i fanów statystyk.",
    features: [
      "Forma drużyn i historia bezpośrednich spotkań",
      "Statystyki meczowe i tabele",
      "Prognoza procentowa wyniku z uzasadnieniem",
      "Analiza AI przed meczem w prostym języku",
      "Ulubione drużyny i rozgrywki",
    ],
    legal: "Prognozy mają charakter wyłącznie informacyjny i nie gwarantują wyniku. Aplikacja przeznaczona dla osób pełnoletnich.",
  },
  {
    id: "digilive",
    title: "DigiLive Hypnotherapy",
    short: "Profesjonalna hipnoterapia na żywo — sesja 1:1 z prawdziwą terapeutką.",
    categories: ["zdrowie"],
    cover: "/img/covers/digilive.jpg",
    accent: "from-violet-500 to-cyan-400",
    status: "offer",
    price: 349,
    price_note: "za sesję 60 min · pierwsza konsultacja wstępna 20 min GRATIS",
    cta: { href: "/live/", label: "Umów sesję na żywo", free: "Umów bezpłatną konsultację (20 min)" },
    screenshots: [
      "/img/screenshots/live-1.jpg",
      "/img/screenshots/live-2.jpg",
      "/img/screenshots/live-3.jpg",
      "/img/screenshots/live-4.jpg",
    ],
    desc: "DigiLive to profesjonalna hipnoterapia na żywo, online — indywidualne, 60-minutowe sesje 1:1 z prawdziwą, wykwalifikowaną i wyspecjalizowaną terapeutką. To nie jest nagranie ani chatbot AI: każdą sesję prowadzi na żywo prawdziwy specjalista, w bezpiecznej i poufnej przestrzeni. Rezerwacja jest prosta: zakładasz konto, otwierasz profil terapeutki, wybierasz rzeczywiście dostępny termin w kalendarzu, płacisz 349 PLN i otrzymujesz automatyczne potwierdzenie. 15 minut przed startem aktywuje się przycisk DOŁĄCZ DO SESJI — rozmowa audio/video odbywa się bezpośrednio w platformie DigiLive, bez Zooma i Teams. Nie wiesz, czy hipnoterapia jest dla Ciebie? Pierwsza konsultacja wstępna (20 minut) jest GRATIS — to rekonesans, po którym zdecydujesz, czy ta forma terapii Ci odpowiada.",
    features: [
      "Sesja LIVE 1:1 z prawdziwą, wykwalifikowaną terapeutką — 60 minut, 349 PLN",
      "Pierwsza konsultacja wstępna 20 min GRATIS — sprawdź, czy ta forma terapii jest dla Ciebie",
      "Kalendarz pokazujący wyłącznie rzeczywiście dostępne terminy — bez podwójnych rezerwacji",
      "Automatyczne potwierdzenie rezerwacji i przypomnienia 24 h oraz 1 h przed sesją",
      "Wbudowany moduł audio/video — sesja bezpośrednio w DigiLive, bez Zooma i Teams",
      "Panel klienta: nadchodzące sesje, historia, status płatności, powiadomienia",
      "Pełna poufność: szyfrowane połączenie, dane nigdy nie trafiają do osób trzecich",
      "Interfejs w języku polskim z przełącznikiem na angielski (PL/EN)",
    ],
    legal: "Hipnoterapia nie zastępuje diagnostyki ani leczenia medycznego. W przypadku chorób lub stanów wymagających opieki medycznej skonsultuj się z lekarzem.",
  },
];
